export default __webpack_public_path__ + "components/page-header/static/tide-badge--dark-b24f47d519b5d072ed7cae35a83c898c.svg";